module.exports = __webpack_public_path__ + "img/logo.9e0832b0.png";